var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('el-date-picker',{staticClass:"calendar",attrs:{"format":"yyyy-MM-dd","type":"date","placeholder":_vm.$t('select_a_date'),"picker-options":_vm.datePickerOptions,"value-format":"yyyy-MM-dd"},on:{"change":_vm.onDateSelect},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b93bd3fe","hasScoped":false,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/calendar.vue
// module id = null
// module chunks = 